import React, { useState } from 'react';
import { Box, Paper, TextField, Button, Typography, Alert, CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import { LockReset } from '@mui/icons-material';
import apiService from '../../services/api';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await apiService.forgotPassword(email);
      setSuccess(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#F7F6F2">
      <Paper sx={{ p: 4, width: '100%', maxWidth: 420, borderRadius: 3 }}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Box sx={{ bgcolor: '#F3E6CD', borderRadius: '50%', p: 1.5, mb: 1.5 }}>
            <LockReset sx={{ color: '#C08A2E', fontSize: 32 }} />
          </Box>
          <Typography variant="h5" fontWeight="bold">Forgot Password</Typography>
          <Typography variant="body2" color="text.secondary" mt={0.5} textAlign="center">
            Enter your email and we'll send you a reset link
          </Typography>
        </Box>

        {success ? (
          <Alert severity="success" sx={{ borderRadius: 2 }}>
            If that email is registered, a reset link has been sent. Check your inbox and follow the link to set a new password.
          </Alert>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{error}</Alert>}
            <TextField
              fullWidth
              label="Email Address"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              sx={{ mb: 2 }}
              autoFocus
            />
            <Button type="submit" fullWidth variant="contained" size="large" disabled={loading || !email} sx={{ py: 1.5 }}>
              {loading ? <CircularProgress size={22} color="inherit" /> : 'Send Reset Link'}
            </Button>
          </form>
        )}

        <Box textAlign="center" mt={2}>
          <Link to="/login" style={{ color: '#C08A2E', textDecoration: 'none', fontSize: '0.875rem' }}>
            Back to Login
          </Link>
        </Box>
      </Paper>
    </Box>
  );
};

export default ForgotPassword;
